import { ReviewPeriod } from "src/app/models/review-period.model";
import { ReviewTypeStrategyBase } from "../review-type-strategy-base";
import { ReviewPeriodHelper } from "src/app/helpers/review-period.helper";
import { DateHelper } from "src/app/shared/helpers";

export class SziluettStrategy extends ReviewTypeStrategyBase {
  
    constructor() {
        super();
            
    }

    isReviewAllowed(rp: ReviewPeriod, isSelf: boolean): boolean {
        return ReviewPeriodHelper.isRpOpen(rp) && isSelf;
    }

    isGoalAllowed(rp: ReviewPeriod): boolean {
        return false; // Goals are not allowed in Sziluett review type
    }
}